import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TagContainer from "./components/TagContainer";
import KeywordContainer from "./components/KeywordContainer";
import { useMediaQuery } from "react-responsive";
import Seperator from "./components/Seperator";

import {
    graphql,
    createPaginationContainer,
    createFragmentContainer,
    commitLocalUpdate,
} from "react-relay";
import environment from "./Environment";
import LeadViewContainer from "./LeadViewContainer";
import { useTheme } from "./contexts/ThemeContext";
import KeyPointsContainer from "./KeyPointsContainer";
import "./AnalysePage.css";

function CurrentAnalytics(props) {
    let [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);
    const [showHeader, setShowHeader] = useState(false);

    const [isLeadsClick, setIsLeadsClick] = useState(true);
    const [isEntitiesClick, setIsEntitiesClick] = useState(false);


    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = (e) => {
        e.preventDefault();

        if (window.pageYOffset + 500) {
            setScrolled(window.pageYOffset + 500);
        }
    };

    function onLeadsClick(e) {
        e.preventDefault();
        setIsLeadsClick(true);
        setIsEntitiesClick(false);
    }

    function onEntitiesClick(e) {
        e.preventDefault();
        setIsLeadsClick(false);
        setIsEntitiesClick(true);
    }

    const generateSettings = () => {};
    useEffect(() => {
        if (scrolled > coords) {
            setShowHeader(true);
        } else {
            setShowHeader(false);
        }
        // let showHeader = scrolled > coords ? "true" : "false";
    }, [scrolled, coords]);




    return (
        <>
            <div className={`home-view-container theme-${theme.light}`}>
                <div
                    className={`header header-fixed-true theme-${theme.light}`}
                >
                    <div className={`theme-${theme.light}`}></div>
                </div>
                <div
                    className={`analyse-container theme-${theme.light} theme-${theme.paragraph} xtheme-${theme.border}`}
                >
                    <div className={``}>
                        <div
                            className={`right-nav-category theme-${theme.light}`}
                        >
                            <button
                                onClick={onLeadsClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isLeadsClick}`}
                            >
                                <span>Key Points</span>
                            </button>

                            <button
                                onClick={onEntitiesClick}
                                className={`theme-${theme.paragraph} right-nav-link-button right-nav-link-button-${isEntitiesClick}`}
                            >
                                <span>Entities</span>
                            </button>
                            <Seperator />
                            <div>
                                {/* <h2 className="current-analytics-headline">{props.title}</h2> */}
                            </div>
                        </div>

                        <div className="analyse-search-content">
                            {isLeadsClick ? (
                                <div>
                                    <div className="leadview-wrapper">
                                        <div>
                                            <div className="keywords-container">
                                                <KeyPointsContainer postId={props.postId} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CurrentAnalytics;
